import React from "react";
import { testimonials } from "../constants";

/* ═══════════════════════════════════════════════════════════
   FEEDBACKS — Luxury Testimonials
   Gold quote marks · glass cards · liquid reveals
   ═══════════════════════════════════════════════════════════ */

const FeedbackCard = ({ testimonial, name, designation, company, image }) => (
  <div className="lux-card reveal-fade p-10 flex flex-col">
    {/* Gold quote mark */}
    <span
      className="font-display text-6xl leading-none text-champagne-500/60"
      aria-hidden="true"
    >
      "
    </span>

    <p className="lux-body mt-4 flex-1">{testimonial}</p>

    <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between gap-4">
      <div>
        <p className="font-grotesk text-sm text-silver-100">
          <span className="text-champagne-500">@</span> {name}
        </p>
        <p className="text-xs text-silver-500 mt-1">
          {designation} · {company}
        </p>
      </div>
      <img
        src={image}
        alt={`${name} avatar`}
        className="w-12 h-12 rounded-full object-cover border border-champagne-500/20"
        loading="lazy"
      />
    </div>
  </div>
);

const Feedbacks = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">What others say</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Testimonials</span>
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {testimonials.map((t, i) => (
          <FeedbackCard key={t.name} {...t} />
        ))}
      </div>
    </div>
  );
};

export default Feedbacks;